const state = () => ({
  token: "",
  info: null,
});
// getters
const getters = {
  token: (state: any) => state.token,
  info: (state: any) => state.info,
};
const mutations = {
  SET_TOKEN: (state: any, token: string) => {
    state.token = token;
  },
  SET_USERINFO: (state: any, info: string) => {
    state.info = info;
  },
};

const actions = {
  // 登录
  setToken({ commit }, token) {
    commit("SET_TOKEN", token);
  },
  setUserInfo({ commit }, info) {
    commit("SET_USERINFO", info);
  },
  // 退出
  logOut({ commit }) {
    commit("SET_TOKEN", null);
    commit("SET_INFO", null);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
